import { Typography, Button } from '@qtm/react2';
import { createRoot } from 'react-dom/client';
import splashBg from './styles/images/Splash-Background.svg';
import TpS3nsLogo from './styles/images/TP-S3NS.svg';
import EMDLogo from './styles/images/EMD_Logo_Splash.svg';
import './styles/main.css';

const container = document.getElementById('root');
const root = createRoot(container);

const App = () => {
  return (
    <div className="flex flex-col" style={{ height: '100vh' }}>
      <div
        className="flex flex-1 items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `url(${splashBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div
          id="splash-box"
          className="flex justify-center flex-col flex-1 h-full overflow-auto p-m rounded-md"
        >
          <div className="flex flex-col bg-white-100 shadow-xl-light mb-m rounded-md">
            <div className="flex flex-1 justify-center bg-bluegrey-25 rounded-md">
              <img className="logo" src={EMDLogo} alt="EMD logo" />
            </div>
            <div className="flex flex-col p-l" style={{ gap: '24px' }}>
              <div className="flex items-end" style={{ gap: '24px' }}>
                <div className="flex flex-col flex-1" style={{ gap: '8px' }}>
                  <Typography component="subtitle-2" fontWeight="bold">
                    EMD has moved!
                  </Typography>
                  <Typography component="body-2">
                    EMD has been moved to the new TP-S3NS platform. Nothing needs to be done on your
                    side, only click on the link below to reach the EMD on this new platform.
                  </Typography>
                </div>
                <div
                  className="flex items-center justify-center border border-bluegrey-200"
                  style={{
                    width: '216px',
                    height: '136px',
                    borderRadius: '4px',
                    padding: '24px 32px',
                    flexShrink: 0,
                  }}
                >
                  <img className="sens-logo" src={TpS3nsLogo} alt="TP-S3NS" />
                </div>
              </div>
              <div>
                <Button
                  variant="filled"
                  color="primary"
                  classes="w-full"
                  onClickEvent={() => {
                    window.location.href = 'https://emd.cloud.thales/landingpage';
                  }}
                >
                  <div className="flex w-full items-center justify-center">
                    <span>Access the EMD on TP-S3NS</span>
                    <svg
                      className="ml-xs"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 12h14M13 6l6 6-6 6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-col bg-white-100 shadow-xl-light rounded-md py-xl px-l">
            <Typography component="body-1" fontWeight="bold">
              Need help?
            </Typography>
            <Typography component="body-2">
              Contact our support team if you face any issues.
            </Typography>
            <div className="mt-xs">
              <Button
                variant="outline"
                color="primary"
                classes="w-full"
                size="small"
                onClickEvent={() => {
                  window.location.href =
                    'mailto:FR-TGS-CONTACT-ENG-EMD@thalesgroup.com?subject=EMD Support';
                }}
              >
                <div className="flex w-full items-center justify-center">
                  <svg
                    className="mr-xs"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 5h16v14H4V5zm0 2l8 6 8-6"
                      stroke="#041295"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>Contact Support Team</span>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center p-xs">
        <Typography component="caption-1" classes="text-green-500" fontWeight="medium">
          THALES GROUP LIMITED DISTRIBUTION
        </Typography>
      </div>
    </div>
  );
};

root.render(<App />);
